import React from 'react';
import { PRODUCT_ANALYTICS_EVENT_NAMES } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/analytics/types.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import IssueSelector from './issue-selector/index.tsx';
import type { Props } from './types.tsx';

function IssueFilter({
	issues,
	issueFilter,
	rollupBy,
	setIssueFilter,
	issueTypes,
	projectsById,
	onFilterChange,
	isOpen = false,
}: Props) {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<IssueSelector
			isOpen={isOpen}
			issues={issues}
			issueId={issueFilter}
			onChangeDependencyIssue={(issue) => {
				if (issue) {
					setIssueFilter(issue.id);
				} else {
					setIssueFilter(null);
				}
				onFilterChange();

				const [actionSubject, action] =
					PRODUCT_ANALYTICS_EVENT_NAMES.UPDATED_DEPENDENCY_ISSUE_FILTER.split(' ');
				fireUIAnalytics(
					createAnalyticsEvent({
						action,
						actionSubject,
					}),
					{
						issue: issue ? issue.id : '',
					},
				);
			}}
			projectsById={projectsById}
			issueTypes={issueTypes}
			rollupBy={rollupBy}
		/>
	);
}

export default IssueFilter;
